/**
 * @generated SignedSource<<e2333548a41244f4c9fad529328494f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedPageBreadcrumbs_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"sellerBrandingHelpers_user">;
  readonly " $fragmentType": "SbSharedPageBreadcrumbs_user";
};
export type SbSharedPageBreadcrumbs_user$key = {
  readonly " $data"?: SbSharedPageBreadcrumbs_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedPageBreadcrumbs_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedPageBreadcrumbs_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmRewards",
              "kind": "LinkedField",
              "name": "rewards",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ParentProgram",
                  "kind": "LinkedField",
                  "name": "currentProgram",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LoyaltyProgram",
                      "kind": "LinkedField",
                      "name": "programInfo",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "618aa8450b032c00c4001bca8cb8f003";

export default node;
